import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import { SURFACE_CONDITIONS } from '../custom-mpi/mpiReportForm';

import * as data from '../../../utils/data';
import * as utils from '../../../utils/utilities';

class PAUTOverviewForm extends Form {
	state = {
		data: {
			processType: '',
			surfaceCondition: '',
			testingMethod: '',
			couplant: '',
			materialTemperature: '',
			equipmentModel: '',
			equipmentSrNo: '',
			calibrationDate: new Date(),
			calibrationDue: new Date(),
			section: '',
			calibrationBlock: '',
			software: '',
			reflector: '',
			scanImage: [],
			remark: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		processType: Joi.string().min(3).required().label('Process Type'),
		calibrationDate: Joi.date()
			.less('now')
			.required()
			.label('Calibration Date'),
		calibrationDue: Joi.date().required().label('Calibration Due Date'),
		surfaceCondition: Joi.string().min(3).required().label('Surface Condition'),
		materialTemperature: Joi.number()
			.integer()
			.required()
			.label('Material Temperature (deg Celcius)'),
		testingMethod: Joi.string().min(3).required().label('Testing Method'),
		equipmentModel: Joi.string().min(3).required().label('Equipment Model'),
		equipmentSrNo: Joi.string().min(3).required().label('Equipment SR Number'),
		couplant: Joi.string().min(3).required().label('Couplant'),
		section: Joi.string().min(3).required().label('Internal / External'),
		calibrationBlock: Joi.string()
			.min(3)
			.required()
			.label('Ref. Calibration Block'),
		software: Joi.string().min(3).required().label('Software'),
		reflector: Joi.string().min(3).required().label('Reference Block'),
		remark: Joi.string().min(3).required().label('Remarks'),
		scanImage: Joi.array().min(1).required().label('Scan Image'),
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	mapInspectionData = () => {
		const apiData = { ...this.state.data };
		apiData.scanImage = (apiData.scanImage[0] as any).src;

		return apiData;
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.mapInspectionData());

		this.setState({
			data: {
				surfaceCondition: '',
				testingMethod: '',
				couplant: '',
				materialTemperature: '',
				processType: '',
				equipmentModel: '',
				equipmentSrNo: '',
				calibrationDate: new Date(),
				calibrationDue: new Date(),
				section: '',
				software: '',
				calibrationBlock: '',
				reflector: '',
				scanImage: [],
				remark: '',
			},
		});
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'processType',
							label: 'Process Type',
							placeholder: 'Enter Process Type',
						})}
					</div>

					<div className="col">
						{this.renderDatePicker({
							name: 'calibrationDate',
							label: 'Calibration Date',
							placeholderText: 'Select Calibration Date',
						})}
					</div>

					<div className="col">
						{this.renderDatePicker({
							name: 'calibrationDue',
							label: 'Calibration Due Date',
							placeholderText: 'Select Calibration Due Date',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							options: SURFACE_CONDITIONS,
							name: 'surfaceCondition',
							label: 'Surface Condition',
							placeholder: 'Enter Surface Condition',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'materialTemperature',
							label: 'Material Temperature (deg Celcius)',
							placeholder: 'Enter Material Temperature (deg Celcius)',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							name: 'testingMethod',
							type: 'text',
							label: 'Testing Method',
							placeholder: 'Enter Testing Method',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							name: 'equipmentModel',
							type: 'text',
							label: 'Equipment Model',
							placeholder: 'Enter Equipment Model',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'equipmentSrNo',
							label: 'Equipment SR Number',
							placeholder: 'Enter Equipment SR Number',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'reflector',
							label: 'Reference Block',
							placeholder: 'Enter Reference Block',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'remark',
							label: 'Remarks',
							placeholder: 'Enter Remarks',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'calibrationBlock',
							label: 'Ref. Calibration Block',
							placeholder: 'Enter Ref. Calibration Block',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'software',
							label: 'Software',
							placeholder: 'Enter Software',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'couplant',
							label: 'Couplant',
							placeholder: 'Enter Couplant',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							name: 'section',
							label: 'Internal / External',
							placeholder: 'Select Internal / External',
							options: data.getSectionOptions(),
						})}
					</div>

					<div className="col">
						{this.renderFileInput({
							max: 1,
							multiple: false,
							name: 'scanImage',
							accept: 'image/*,application/pdf',
							label: 'Scan Image',
							sublabel: 'Upload PAUT Scan Image',
							types: utils.getFileUploadTypes(),
						})}
					</div>
				</div>

				{this.renderButton('Submit')}
			</form>
		);
	}
}

export default PAUTOverviewForm;
